import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import {attributes, header, jsonObject,} from '../../data/locationGroups/locationGroup';
import RequestDefinition from '../RequestDefinition';
import ObjectDefinition from '../ObjectDefinition';

export default new RouteComponent(`${apiRoutePrefix}/location-groups`, () => {
    return (
        <div>
            <ObjectHeader data={ header }/>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The location group object',
                attributes: attributes,
                jsonObject: jsonObject
            } }/>

            {
                header.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
